const faqs = [
  {
    q: 'Como funciona o período de 30 dias grátis?',
    a: 'Você cria a conta e tem acesso completo ao plano Pro por 30 dias, sem precisar informar cartão de crédito. Ao final do período, você decide se quer continuar por R$199/mês. Sem compromisso.',
  },
  {
    q: 'O cliente precisa baixar algum app?',
    a: 'Não. O site do seu restaurante é um PWA — funciona no navegador do celular sem instalação. O cliente escaneia o QR code ou acessa o link e já está no cardápio.',
  },
  {
    q: 'Existe taxa por pedido ou comissão?',
    a: 'Zero. Você paga apenas a mensalidade do plano — nenhuma comissão em cima dos seus pedidos. O dinheiro da venda é todo seu. Pix via Woovi, máx. R$1/transação.',
  },
  {
    q: 'Quanto tempo leva para colocar o restaurante no ar?',
    a: 'A maioria dos restaurantes vai ao ar em menos de 10 minutos. Crie a conta, configure o cardápio e publique o site. Pronto.',
  },
  {
    q: 'Posso usar o WaitHere junto com o iFood?',
    a: 'Sim. O WaitHere complementa — você continua no iFood mas ganha um canal próprio de pedidos sem comissão. Muitos restaurantes usam os dois.',
  },
  {
    q: 'Funciona para qualquer tipo de restaurante?',
    a: 'Sim — restaurante à la carte, pizzaria, lanchonete, cafeteria, hamburgeria, delivery exclusivo, food truck. Qualquer modelo de negócio que venda comida.',
  },
  {
    q: 'Posso cancelar quando quiser?',
    a: 'Sim. Sem fidelidade, sem multa. Você pode cancelar a qualquer momento e exportar todos os seus dados.',
  },
]

export default function FAQ() {
  return (
    <section className="bg-neutral-50 px-5 py-16 sm:px-8 sm:py-20 lg:px-16 lg:py-24">
      <div className="max-w-[800px] mx-auto">
        <div className="text-[11px] font-bold uppercase tracking-[2px] text-neutral-400 mb-3">
          Dúvidas frequentes
        </div>
        <h2 className="text-[30px] sm:text-[38px] lg:text-[50px] font-black tracking-tight leading-[1.1]">
          Perguntas comuns.
        </h2>

        <div className="mt-10">
          {faqs.map((faq, i) => (
            <div key={i} className="border-b border-neutral-200 py-5 lg:py-6">
              <div className="text-base font-bold mb-2.5 leading-[1.35]">{faq.q}</div>
              <p className="text-[15px] text-neutral-500 leading-[1.65]">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
